import React from 'react';

/**
 * Consistent page header band used by every public page.
 * Keeps the icon / title / subtitle pattern in one place instead of being
 * re-implemented (with slightly different spacing) on each page.
 */
const PageHero = ({ icon: Icon, title, subtitle, actions, children }) => (
  <div className="page-hero">
    <div className="container-page flex flex-wrap items-center gap-3 py-4 sm:gap-4 sm:py-5">
      {Icon ? (
        <span className="page-hero-icon" aria-hidden="true">
          <Icon className="h-5 w-5" strokeWidth={2} />
        </span>
      ) : null}

      <div className="min-w-0 flex-1">
        <h1 className="text-lg font-bold leading-tight text-ink-900 sm:text-xl">{title}</h1>
        {subtitle ? (
          <p className="mt-0.5 text-xs text-ink-500 sm:text-sm">{subtitle}</p>
        ) : null}
      </div>

      {actions ? <div className="flex flex-shrink-0 items-center gap-2">{actions}</div> : null}
      {children}
    </div>
  </div>
);

export default PageHero;
